import React, { Suspense, lazy, useEffect, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import nprogress from 'nprogress';
import 'nprogress/nprogress.css';
import { AnimatePresence, motion } from 'framer-motion';
import Loading from './Components/Loading';
import FloatingContactButtons from './Components/FloatingContactButtons';
import OfferPopup from './Components/OfferPopup';

import './App.css';

const About = lazy(() => import('./About/About'));
const Mentorship = lazy(() => import('./Mentorship/Mentorship'));
const Landing = lazy(() => import('./Landing/Landing'));
const ForexEducation = lazy(() => import('./ForexEducation/ForexEducation'));
const Automation = lazy(() => import('./Automation/Automation'));
const Strategy = lazy(() => import('./Strategy/Strategy'));
const Tools = lazy(() => import('./Tools/Tools'));
const WhiteLebel = lazy(() => import('./WhiteLebel/WhiteLebel'));
const WttBot = lazy(() => import('./WttBot/WttBot'));
const Contact = lazy(() => import('./Contact/Contact'));
const Package = lazy(() => import('./Package/Package'));
const Payment = lazy(() => import('./Payment/Payment'));
const TermsAndCondition = lazy(() => import('./Pages/TermsAndCondition'));
const PrivacyPolicy = lazy(() => import('./Pages/PrivacyPolicy'));
const RefundPolicy = lazy(() => import('./Pages/RefundPolicy'));
const Disclaimer = lazy(() => import('./Pages/Disclaimer'));
const Cookies = lazy(() => import('./Pages/Cookies'));
const Affiliate = lazy(() => import('./Pages/Affiliate'));




function App() {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    nprogress.start();

    setIsLoading(true);

    const timer = setTimeout(() => {
      setIsLoading(false);
      nprogress.done();
    }, 3000);

    return () => {
      clearTimeout(timer);
      nprogress.done();
    };
  }, [location]);

  return (
    <div>
      {/* Show loading indicator if loading state is true */}
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <Suspense fallback={<Loading />}>
            <AnimatePresence mode="wait">
              <Routes location={location} key={location.pathname}>
                <Route path="/" element={<PageTransition><Landing /></PageTransition>} />
                <Route path="/about" element={<PageTransition><About /></PageTransition>} />
                <Route path="/mentorship" element={<PageTransition><Mentorship /></PageTransition>} />
                <Route path="/educations" element={<PageTransition><ForexEducation /></PageTransition>} />
                <Route path="/automation" element={<PageTransition><Automation /></PageTransition>} />
                <Route path="/strategy" element={<PageTransition><Strategy /></PageTransition>} />
                <Route path="/tools" element={<PageTransition><Tools /></PageTransition>} />
                <Route path="/package" element={<PageTransition><Package /></PageTransition>} />
                <Route path="/whitelabel" element={<PageTransition><WhiteLebel /></PageTransition>} />
                <Route path="/wttbot" element={<PageTransition><WttBot /></PageTransition>} />
                <Route path="/contact" element={<PageTransition><Contact /></PageTransition>} />
                <Route path="/terms" element={<PageTransition><TermsAndCondition /></PageTransition>} />
                <Route path="/privacy" element={<PageTransition><PrivacyPolicy /></PageTransition>} />
                <Route path="/refund" element={<PageTransition><RefundPolicy /></PageTransition>} />
                <Route path="/disclaimer" element={<PageTransition><Disclaimer /></PageTransition>} />
                <Route path="/cookies" element={<PageTransition><Cookies /></PageTransition>} />
                <Route path="/affiliate" element={<PageTransition><Affiliate /></PageTransition>} />
                <Route path="/payment" element={<PageTransition><Payment /></PageTransition>} />
              </Routes>
            </AnimatePresence>
          </Suspense>
          <OfferPopup />
          <FloatingContactButtons />
        </>
      )}
    </div>
  );
}

const PageTransition = ({ children }) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -100 }}
      transition={{ duration: 0.5 }}
    >
      {children}
    </motion.div>
  );
};

export default App;
